<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-问诊调查表-修改
    -->
    <el-dialog
    title="修改问诊调查表"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="90%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
     
      <el-form-item label="选择医生" >
        <el-select id="searchType" v-model="form.doctor_id" class="searchType">
          <el-option v-for="(item,index) in doctor" :key="index" :label="item.name" :value="item.doctor_id"></el-option>
                
        </el-select>
      </el-form-item>
  


      <el-form-item label="问诊调查表名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入问诊调查表名称" class="max-w460"></el-input></el-form-item>
    
      
        <el-form-item label="问诊调查表字段" >
        <el-button size="small" type="primary" @click="addSetting" >新增问诊调查表字段</el-button>
        <el-table :data="form.setting"  border size="mini" style="width: 100%;margin-top: 20px;">
          <el-table-column prop="name" label="编号"  width="100">
              <template v-slot="scope">
                <div class="d-s-c">
               
                  {{ scope.row.number }}
                </div>
              </template>
            </el-table-column>
          <el-table-column prop="name" label="排序" width="80" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 90px;"  v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
                </div>
              </template>
            </el-table-column>


            <el-table-column prop="name" label="题目"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 150px;" type="textarea" v-model="scope.row.name"  placeholder="请输入题目"></el-input>
                </div>
              </template>
            </el-table-column>     


            <el-table-column prop="name" label="题目类型"   width="150" >
                <template v-slot="scope">
        
                <el-select id="searchType" v-model="scope.row.code" class="searchType">
                  <el-option v-for="(item,index) in codearr" :key="index" :label="item.name" :value="item.code"></el-option>
                        
                </el-select>
              </template>
            </el-table-column>     

            
            <el-table-column prop="name" label="是否必填"   width="100" >
                        <template v-slot="scope">
                          <div class="d-s-c">
                            <el-select id="searchType" v-model="scope.row.is_must" class="searchType">
                            <el-option v-for="(item,index) in mustarr" :key="index" :label="item.name" :value="item.id"></el-option>
                                  
                          </el-select>
                            </div>
                        </template>
                      </el-table-column>     





            
            <el-table-column prop="name" label="选项"   width="550" >
                <template v-slot="scope">
                  <el-button size="small"  v-if="scope.row.code == 1 || scope.row.code == 2"  
                  type="primary" @click="addOption(scope.$index)" >增加选项</el-button>
                  

                  <el-table :data="scope.row.option" 
                  
                  
                  v-if="scope.row.code == 1 || scope.row.code == 2" 
                  border size="mini" style="width: 100%;margin-top: 20px;">
                    <el-table-column prop="name" label="编号"  width="100">
                        <template v-slot="scope1">
                          <div class="d-s-c">
                        
                            {{ scope1.row.number }}
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="name" label="选项内容"   width="200" >
                        <template v-slot="scope1">
                          <div class="d-s-c">
                            <el-input style="width: 150px;" type="textarea" v-model="scope1.row.name"  placeholder="请输入选项内容"></el-input>
                          </div>
                        </template>
                      </el-table-column>     


                      <el-table-column prop="name" label="排序" width="80" >
                          <template v-slot="scope1">
                            <div class="d-s-c">
                              <el-input style="width: 90px;"  v-model="scope1.row.sort"  placeholder="请输入排序"></el-input>
                            </div>
                          </template>
                        </el-table-column>


                      <el-table-column prop="name" label="操作"  width="70">
                        <template v-slot="scope1">
                          <div style="color: blue;" @click="delOption(scope.$index,scope1.$index)">删除</div>

                        </template>
                      </el-table-column>
          </el-table>




              </template>
            </el-table-column>     



  
            <el-table-column prop="name" label="操作"  width="70">
              <template v-slot="scope">
                <div style="color: blue;" @click="delSetting(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item>    

 
      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="pre" :loading="loading">预览题目</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import HquesApi from '@/api/hques.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        setting:[],
        doctor_id:0
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入问诊调查表名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
         label:[],
      /*省市区*/
      director:[],
      hospital:[],
      codearr:[{
        code:1,
        'name':"单选题"
      },{
        code:2,
        'name':"多选题"
      },{
        code:3,
        'name':"填空题"
      }],
      mustarr:[{
        id:1,
        'name':"是"
      },{
        id:0,
        'name':"否"
      }],
      doctor:[]
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getDoctor();
  },
  props: ["open_add","hques_id"],
  methods: {
    getDoctor(){
        var self = this;
        HquesApi.getDoctor({}, true)
            .then(data => {
              self.doctor = data.data
            })
            .catch(error => {
              self.loading = false;
            });
    },
    delSetting(index){
        this.form.setting.splice(index,1)
    },
    pre(){
      var url =  window.open('https://yfk.lanxiaobao.com.cn/h5/#/plus2/pages/hques/pre?hques_id='
      +this.hques_id+'&type=1')
    },
    addSetting(){
      this.form.setting.push({
          "number":this.randomString(8,this.randomString(6,0)),
          "sort":50,
          "name":"",//题目名称
          "code":1,//1 单选题  2  多选题  3 填空题
          "is_must":0,//0 不是必须  1  是必须
          "option":[],//问题选项
          "answer":"",
      });
    },
    addOption(index){
      console.log(index)
      this.form.setting[index].option.push({
          "number":this.randomString(8,this.randomString(6,0)),
          "sort":50,
          "name":"",//题目名称
      });
      this.$forceUpdate()
    },
    delOption(index1,index2){
      this.form.setting[index1].option.splice(index2,1)
      this.$forceUpdate()
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      HquesApi.detail({hques_id: self.hques_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true
          self.loading = false;
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.hques_id = self.hques_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          HquesApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
  /*上传商品图片*/
  returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = e;
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },
      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/hospital/hques/index/part/edit.vue